/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function EmojiAddReaction({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#EmojiAddReaction_svg__a)"><path d="M4.444 2.679A6.4 6.4 0 0 1 8 1.6.6.6 0 0 0 8 .4 7.6 7.6 0 1 0 15.6 8a.6.6 0 1 0-1.2 0 6.4 6.4 0 1 1-9.956-5.321Z" /><path d="M5.287 9.732a.6.6 0 0 0-1.074.536C4.837 11.515 6.123 12.6 8 12.6c1.878 0 3.163-1.085 3.787-2.332a.6.6 0 0 0-1.074-.536C10.26 10.639 9.353 11.4 8 11.4s-2.26-.761-2.713-1.668ZM6 5.4a.6.6 0 0 1 .6.6v1.5a.6.6 0 1 1-1.2 0V6a.6.6 0 0 1 .6-.6ZM10.6 6a.6.6 0 1 0-1.2 0v1.5a.6.6 0 1 0 1.2 0V6ZM13 .4a.6.6 0 0 1 .6.6v1.65h1.65a.6.6 0 1 1 0 1.2H13.6V5.5a.6.6 0 1 1-1.2 0V3.85h-1.65a.6.6 0 0 1 0-1.2h1.65V1a.6.6 0 0 1 .6-.6Z" /></g><defs><clipPath id="EmojiAddReaction_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;